// @flow

import { takeLatest, call, put } from 'redux-saga/effects';
import type { IOEffect } from 'redux-saga/effects';

import ActionTypes from './action-types';

import getTopExtendedActivitiesApi from './apis';

export type ExtendedActivity = {
  base_duration: number,
  actual_duration: number,
  name: string,
  parent: string,
  id: number,
  ratio: number,
  wbs: string,
};

type TopExtendedActivitiesResponse = {
  activities: Array<ExtendedActivity>,
};

export type TopExtendedActivitiesAction = {|
  +type: $PropertyType<typeof ActionTypes, 'GET_TOP_EXTENDED_ACTIVITIES_SUCCESS'>,
  data: TopExtendedActivitiesResponse,
|} | {|
  +type: $PropertyType<typeof ActionTypes, 'GET_TOP_EXTENDED_ACTIVITIES_FAIL'>,
|};

function* getTopExtendedActivities(action: { data: { projectId: string, startDate: string } }): Generator<IOEffect, void, any> {
  try {
    const response: { data: TopExtendedActivitiesResponse } = yield call(getTopExtendedActivitiesApi, action.data.projectId, action.data.startDate);
    const actionData: TopExtendedActivitiesAction = { type: ActionTypes.GET_TOP_EXTENDED_ACTIVITIES_SUCCESS, data: response.data };
    yield put(actionData);
  } catch (e) {
    const actionData: TopExtendedActivitiesAction = { type: ActionTypes.GET_TOP_EXTENDED_ACTIVITIES_FAIL };
    yield put(actionData);
  }
}

export default function* root(): Generator<IOEffect, void, any> {
  yield takeLatest(ActionTypes.GET_TOP_EXTENDED_ACTIVITIES, getTopExtendedActivities);
}
